import Header from '../components/Header';
import * as locCon from '../LocalConstants';
import CustomButton from '../elements/CustomButton';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import { setMultipleValues } from '../hooks/StoreHooks';
import { RefATOField } from '../hooks/StoreHooks';
import * as libCon from '../community-hats-js-library/Constants';

export function ManagerMainApp() {
  const i18n = RefContextLanguage();

  const trade = RefATOField(locCon.AT_OBJECT_PARTICIPANT, libCon.ATF_TRADE);

  // Current Page
  const setCurrentPage = RefSetCurrentPage();

  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={true} includeBackButton={false} />

        {/* Bundle Set Up*/}
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('bundles')}</CustomText>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_SET_UP_BUNDLE)}>
          {i18n.t('setUpBundle')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_DEPLOY_BUNDLE)}>
          {i18n.t('deployBundle')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_SYNC_BUNDLE)}>
          {i18n.t('bundleSync')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_MANAGE_BUNDLE)}>
          {i18n.t('bundleManage')}
        </CustomButton>
        <div className={'horizontalLine'} />

        {/* Data Collection */}
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('data')}</CustomText>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_COLLECT_DATA)}>
          {i18n.t('collectData')}
        </CustomButton>
        {trade === libCon.ATF_STREET_VENDOR ? (
          <CustomButton
            type={locCon.PRIMARY_BUTTON}
            onClick={() => setCurrentPage(locCon.PAGE_COLLECT_DATA_VENDOR_SPOT)}
          >
            {i18n.t('collectDataVendorSpot')}
          </CustomButton>
        ) : (
          <></>
        )}
        <div className={'horizontalLine'} />

        {/* Participant */}
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('participant')}</CustomText>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_PARTICIPANT_UNENROLL)}>
          {i18n.t('unenrollParticipant')}
        </CustomButton>

        <div className={'horizontalLine'} />
        {/* Extras */}
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('extras')}</CustomText>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_TOOLS_MAIN)}>
          {i18n.t('toolsSetUp')}
        </CustomButton>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => setCurrentPage(locCon.PAGE_PARTICIPANT_REPORT)}>
          {i18n.t('participantReport')}
        </CustomButton>

        <div className={'horizontalLine'} style={{ marginTop: '3vh' }} />
        <CustomButton
          type={locCon.DANGER_BUTTON}
          onClick={() =>
            setMultipleValues({
              [locCon.LAST_LOG_IN]: null,
              [locCon.APP_TOKEN]: null,
              [locCon.API_TOKEN]: null,
              [locCon.API_TOKEN_EXPIRY]: null,
            })
          }
        >
          {i18n.t('exit')}
        </CustomButton>
      </div>
    </div>
  );
}

export default ManagerMainApp;

// const styles = {
// };
